<template>
  <div class="books-details">
    <!-- 顶部大图片 -->
    <imgBigCards path="/layout/list/boutiqueTaobaoQuestions"></imgBigCards>
    <!-- 输入框 -->
    <div class="box-input">
      <inputBox @query="inputBoxClick"></inputBox>
    </div>
    <div class="title-box">
      <div class="title">
        <!-- 面包屑 -->
        <!-- <div class="title-left">
          <el-breadcrumb>
            <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
            <el-breadcrumb-item to="/layout/list/boutiqueTaobaoQuestions"
              >精品淘题</el-breadcrumb-item
            >
            <el-breadcrumb-item>正文</el-breadcrumb-item>
          </el-breadcrumb>
        </div> -->
        <!-- 加入收藏 -->
        <div
          v-if="mydata.examInfo.is_collect === 0"
          class="title-right"
          @click="isCollect"
        >
          <el-icon><Star /></el-icon>
          <p>加入收藏</p>
        </div>
        <!-- 取消收藏 -->
        <div v-else class="title-right" @click="isCollect">
          <el-icon class="collectTrue"><Star /></el-icon>
          <p class="collectTrue">取消收藏</p>
        </div>
      </div>
    </div>

    <div class="box-content">
      <div class="content-left">
        <div class="left-1">
          <!-- <div class="left-1-box1"> -->
          <p>
            {{ mydata.examInfo.title }}
          </p>
          <div class="icon-box">
            <div>
              <el-icon><Calendar /></el-icon>
              <!-- <p>{{ mydata.examInfo.create_time }}</p> -->
              <p>
                {{
                  dayjs(mydata.examInfo.create_time * 1000).format("YYYY-MM-DD")
                }}
              </p>
            </div>
            <div class="box-line"></div>
            <div>
              <el-icon><View /></el-icon>
              <p>{{ mydata.examInfo.views }}</p>
            </div>
            <div class="box-line"></div>
            <div>
              <el-icon><Download /></el-icon>
              <p>{{ mydata.examInfo.downloads }}</p>
            </div>
            <div class="box-line"></div>
            <div>
              <el-icon><Menu /></el-icon>
              <p>{{ mydata.examInfo.grade_name }}</p>
              <p>{{ mydata.examInfo.subject_name }}</p>
              <p>{{ mydata.examInfo.type_name }}</p>
              <p>{{ mydata.examInfo.address_name }}</p>
              <p>{{ mydata.examInfo.year_name }}</p>
            </div>
          </div>
          <!-- </div> -->
          <div class="left-1-box2" v-show="mydata.pdfNumPage">
            <!-- 1/{{ mydata.pdfNumPage }}页 -->
            已显示{{ Math.floor(mydata.pdfNumPage * 0.75) }}页 / 共{{
              mydata.pdfNumPage
            }}页
          </div>
          <div class="left-1-box3">
            <div class="box-one">
              <!-- <canvas
                v-show="mydata.fileViewType === 'pdf'"
                id="pdfCanvas"
                style="width: 100%; height: 100%"
              ></canvas>
              <div
                v-show="mydata.fileViewType === 'docx'"
                id="docxBox"
                style="width: 100%; height: 100%"
              ></div>
              <img v-show="mydata.fileViewType === 'image'" id="imageBox" /> -->
            </div>
            <div class="box-two">
              <el-divider>
                <el-icon><Lock /></el-icon>
                <p>下载后查看全部</p>
              </el-divider>
            </div>
          </div>
          <div class="left-1-box4">
            <!-- <el-button type="warning" round @click="downloadPdf"
              >会员下载</el-button
            > -->
            <el-button type="primary" plain @click="downloadPdf"
              >免费下载</el-button
            >

            <!-- 加入收藏按钮 -->
            <el-button
              type="success"
              plain
              v-if="mydata.examInfo.is_collect === 0"
              @click="isCollect"
              >加入收藏</el-button
            >
            <!-- 取消收藏按钮 -->
            <el-button v-else type="success" plain @click="isCollect"
              >取消收藏</el-button
            >
          </div>
        </div>
      </div>
      <div class="content-right">
        <!-- 相关资源 -->
        <div class="left-1-box5">
          <column :title="mydata.title1">
            <template #abc>
              <ul>
                <li
                  class="my-li hover-change-color"
                  v-for="(item, index) in mydata.examInfo.correlation_list"
                  :key="index"
                  @click="liClick(item.id)"
                >
                  <p>{{ item.title }}</p>
                  <p>{{ item.create_time.slice(0, 10) }}</p>
                </li>
              </ul>
            </template>
          </column>
        </div>
        <!-- 热门资源 -->
        <div class="left-2">
          <div class="left-2-box">
            <column :title="mydata.title2">
              <template #abc>
                <ul>
                  <li
                    class="my-li hover-change-color"
                    v-for="(item, index) in mydata.popularResourcesArr"
                    :key="index"
                    @click="liClick(item.id)"
                  >
                    <p>{{ item.title }}</p>
                    <p>{{ item.create_time.slice(0, 10) }}</p>
                  </li>
                </ul>
              </template>
            </column>
          </div>
        </div>

        <!-- 必备好书 -->
        <rightCardBook title="必备好书"></rightCardBook>
        <!-- 必刷好题 -->
        <rightCardProblem title="必刷好题"></rightCardProblem>
        <!-- 必学好课 -->
        <rightCardCourse title="必学好课"></rightCardCourse>
        <div
          class="bookFeedback bookBox"
          @click="bookCorrectionButton"
          style="cursor: pointer"
        >
          <!-- <p>图书反馈</p> -->
          <img src="@/assets/076e927c-ab95-4f5e-902c-4823887218b4.png" alt="" />
          <!-- <img v-complete:src="mydata.imgSrc1" style="max-width: 320px;"> -->
        </div>
        <div
          class="genuineVerify bookBox"
          @click="testAndVerifyButton"
          style="cursor: pointer"
        >
          <!-- <p>正版验证</p> -->
          <img src="@/assets/6168ae6f-966e-4a58-a390-42bacaff094d.png" alt="" />
          <!-- <img v-complete:src="mydata.imgSrc2" style="max-width: 320px;"> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// 必备好书
import rightCardBook from "@/components/rightCardBook/index.vue";
// 必刷好题
import rightCardProblem from "@/components/rightCardProblem/index.vue";
// 必学好课
import rightCardCourse from "@/components/rightCardCourse/index.vue";

import { Calendar } from "@element-plus/icons-vue";
import { View } from "@element-plus/icons-vue";
import { Download } from "@element-plus/icons-vue";
import { Menu } from "@element-plus/icons-vue";
import { Lock } from "@element-plus/icons-vue";

import { useRouter, useRoute } from "vue-router";

import { reactive, ref, watch } from "vue";
import { Star } from "@element-plus/icons-vue";
import imgBigCards from "@/components/imgBigCards/index.vue";
import inputBox from "@/components/inputBox/index.vue";

import column from "@/components/column/index.vue";

import rowBookCards from "@/components/rowBookCards/index.vue";

import dayjs from "dayjs";

// 引入pdfjs-dist插件
import * as pdfjsLib from "pdfjs-dist";
import * as pdfjsWorker from "pdfjs-dist/build/pdf.worker.mjs";
// console.log("pdfjsLib", pdfjsLib);

//引入淘题首页接口
import {
  examDtail,
  examFile,
  examFileNoBlob,
  examshowFile,
  getBlobByUrl,
} from "@/api/boutiqueTaobaoQuestions/topicSubjectDetails/index.js";

//引入淘题搜索列表（高级搜索页面）接口
import { examSearchList } from "@/api/boutiqueTaobaoQuestions/listenBig/index.js";

// 引入加入收藏接口
import { addFavoritesList } from "@/api/personalCenter/myCollection/index.js";
// 引入详情页取消收藏接口
import { cancelCollect } from "@/api/addedServices/index.js";

import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import * as docxPreview from "docx-preview";
const router = useRouter();
const route = useRoute();

const mydata = reactive({
  title1: "相关资源",
  title2: "热门资源",

  ulLi: [
    "二轮复习必备神器二轮复习必备神器",
    "《贵州省2024年普通高等学校招生考试和录取工作方案》解读",
    "山西省太原市高三",
    "《贵州省2024年普通高等学校招生考试和录取工作方案》解读",
    "山西省太原市高三",
    "《贵州省2024年普通高等学校招生考试和录取工作方案》解读",
  ],

  examId: null, // 淘题id值
  examInfo: {}, // 淘题详情
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,

  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //获取的用户信息

  popularResourcesArr: [],
  pdfUrl: "",
  pdfNumPage: 0,
  fileViewType: "",
  progressValue: "",
  loadingShow: false,
  imgSrc1: JSON.parse(localStorage.getItem("slideObj"))
    ? JSON.parse(localStorage.getItem("slideObj"))["44"][0].image
    : "",
  imgSrc2: JSON.parse(localStorage.getItem("slideObj"))
    ? JSON.parse(localStorage.getItem("slideObj"))["45"][0].image
    : "",
});

//详情页搜索跳转到高级搜索页面
function inputBoxClick(type, value) {
  localStorage.setItem("v", value);
  router.push({
    path: "/layout/list/listenBig",
    // query:{
    //   search:value
    // }
  });
}

// 监听路由完整地址
watch(
  () => {
    return route.fullPath;
  },
  (n, o) => {
    // 在watch中判断，如果当前的地址不是自己的页面对应的地址，那么就终止执行（解决缓存组件带来的问题）
    if (!n.includes("/layout/list/topicSubjectDetails")) {
      return;
    }
    init();
  },
  {
    immediate: true,
  }
);

// 初始化函数——淘题详情
function init() {
  // 获取到传递过来的参数
  mydata.examId = route.query.id;
  // 调用淘题详情
  examDtail({ id: mydata.examId }).then((res) => {
    // console.log(res.data, "淘题详情");
    mydata.examInfo = res.data;

    mydata.pdfUrl = mydata.VUE_APP_BASE_HOST + mydata.examInfo.url;
    // 设置title标题
    window.document.getElementsByTagName("title")[0].innerHTML =
      mydata.examInfo.title;
  });
  // 渲染pdf文件
  myRenderPdf(mydata.examId);
}

//热门资源
function examSearchListFN() {
  examSearchList({ is_recommended: 1, is_hot: 1 }).then((res) => {
    mydata.popularResourcesArr = res.data.list;
  });
}

examSearchListFN();

//跳转到淘题详情
function liClick(id) {
  router.push({
    path: "/layout/list/topicSubjectDetails",
    query: { id },
  });
}

////////////////////////////////////////////////
/**加入收藏/取消收藏的点击事件  0未收藏  1已收藏 */
function isCollect() {
  if (mydata.examInfo.is_collect !== 0) {
    // 调用详情页取消收藏接口
    cancelCollect(mydata.userInfo.jwt, {
      type: 1,
      content_id: mydata.examInfo.id,
    }).then((res) => {
      ElMessage({
        message: res.msg,
        type: "success",
      });
      // 查询列表
      init();
    });
  } else {
    // 调用加入收藏接口
    addFavoritesList(mydata.userInfo.jwt, {
      content_id: mydata.examInfo.id,
      type: 1,
    }).then((res) => {
      ElMessage({
        message: res.msg,
        type: "success",
      });
      // 查询列表
      init();
    });
  }
}

////////////////////////////////////////////////
//pdf
async function myRenderPdf(id) {
  // 访问文件地址，获取文件数据
  let res1 = await examshowFile({ id });
  // console.log(res1.data.url);
  let arr = res1.data.url.split(",");

  let boxOne = window.document.getElementsByClassName("box-one")[0];
  boxOne.innerHTML = "";
  arr.forEach(async (item, index) => {
    let res2 = await getBlobByUrl(item);
    // 文件是pdf类型
    if (res2.type === "application/pdf") {
      // let ele = window.document.createElement("canvas");
      // ele.id = "pdfCanvas" + index;
      // boxOne.append(ele);

      mydata.fileViewType = "pdf";
      // 读取文件数据
      let fileReader = new FileReader();
      fileReader.readAsArrayBuffer(res2);
      // 读取文件数据完毕
      fileReader.onload = async (e) => {
        // 转换格式
        let typedarray = new Uint8Array(e.target.result);
        // 使用pdfjs-dist插件进行解析PDF文件
        let pdf = await pdfjsLib.getDocument(typedarray).promise;
        // console.log('pdf',pdf.numPages);
        mydata.pdfNumPage = pdf.numPages;
        
        console.log('总页数',mydata.pdfNumPage);
        let preShowPage = Math.floor(mydata.pdfNumPage * 0.75)
        console.log('应该显示几页',preShowPage);
        
        for (let index2 = 1; index2 <= preShowPage; index2++) {
          let ele = window.document.createElement("canvas");
          ele.id = "pdfCanvas-" + index + '-' + index2;
          boxOne.append(ele);

        // 读取第一页
        // let page = await pdf.getPage(1);
         let page = await pdf.getPage(index2);
        // 缩放比例
        let scale = 1;
        let viewport = page.getViewport({ scale: scale });
        // 获取canvas元素
        // let canvas = document.getElementById("pdfCanvas");
        // let canvas = document.getElementById("pdfCanvas" + index);
         let canvas = document.getElementById("pdfCanvas-" + index + '-' + index2);
        let context = canvas.getContext("2d");
        // 设置canvas宽高
        canvas.height = viewport.height;
        canvas.width = viewport.width;
        const dpr = window.devicePixelRatio || 1;
        const bsr =
          context.webkitBackingStorePixelRatio ||
          context.mozBackingStorePixelRatio ||
          context.msBackingStorePixelRatio ||
          context.oBackingStorePixelRatio ||
          context.backingStorePixelRatio ||
          1;
        const ratio = dpr / bsr;
        canvas.width = viewport.width * ratio;
        canvas.height = viewport.height * ratio;
        canvas.style.width = viewport.width + "px";
        canvas.style.height = viewport.height + "px";
        context.setTransform(ratio, 0, 0, ratio, 0, 0);
        // 渲染PDF文件到canvas元素里面
        let renderContext = {
          canvasContext: context,
          viewport: viewport,
        };
        let end = await page.render(renderContext).promise;
        // 处理宽度（如果宽度比较小，那么就进行缩放）
        let canvasW = Number(canvas.style.width.replace("px", ""));
        if (canvasW < 800) {
          canvas.style.zoom = 800 / canvasW;
        }
        // console.log("渲染完毕了", end);
        }
      };
      // 终止执行代码
      return;
    }
    // 文件是docx类型
    if (
      res2.type ===
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ) {
      let ele = window.document.createElement("div");
      ele.id = "docxBox" + index;
      boxOne.append(ele);

      mydata.fileViewType = "docx";
      // 获取元素
      let docxBox = document.getElementById("docxBox" + index);
      docxPreview.renderAsync(res2, docxBox, null, {
        className: "docx",
        inWrapper: false,
      });
      // 处理宽度（如果宽度比较小，那么就进行缩放）
      let docxBoxW = Number(docxBox.style.width.replace("px", ""));
      if (docxBoxW < 800) {
        docxBox.style.zoom = 800 / docxBoxW;
      }
      // 终止执行代码
      return;
    }
    // 文件是img类型
    if (res2.type.includes("image")) {
      let ele = window.document.createElement("img");
      ele.id = "imageBox" + index;
      boxOne.append(ele);

      mydata.fileViewType = "image";
      // 获取元素
      let imageBox = document.getElementById("imageBox" + index);
      let url = URL.createObjectURL(res2);
      imageBox.src = url;
      // 处理宽度（如果宽度比较小，那么就进行缩放）
      let imageBoxW = Number(imageBox.style.width.replace("px", ""));
      if (imageBoxW < 800) {
        imageBox.style.zoom = 800 / imageBoxW;
      }
      // 终止执行代码
      return;
    }
  });

  // let res1 = await fetch("/mypdf.pdf")
  // let res1 = await fetch("/mydocx.docx")
  // let res1 = await fetch("/mypng.png");
  // let res2 = await res1.blob();
  // console.log("res2", res2);
  // 文件是pdf类型
  // if (res2.type === "application/pdf") {
  //   mydata.fileViewType = "pdf";
  //   // 读取文件数据
  //   let fileReader = new FileReader();
  //   fileReader.readAsArrayBuffer(res2);
  //   // 读取文件数据完毕
  //   fileReader.onload = async (e) => {
  //     // 转换格式
  //     let typedarray = new Uint8Array(e.target.result);
  //     // 使用pdfjs-dist插件进行解析PDF文件
  //     let pdf = await pdfjsLib.getDocument(typedarray).promise;
  //     // console.log('pdf',pdf.numPages);
  //     mydata.pdfNumPage = pdf.numPages;
  //     // 读取第一页
  //     let page = await pdf.getPage(1);
  //     // 缩放比例
  //     let scale = 1;
  //     let viewport = page.getViewport({ scale: scale });
  //     // 获取canvas元素
  //     let canvas = document.getElementById("pdfCanvas");
  //     let context = canvas.getContext("2d");
  //     // 设置canvas宽高
  //     canvas.height = viewport.height;
  //     canvas.width = viewport.width;
  //     const dpr = window.devicePixelRatio || 1;
  //     const bsr =
  //       context.webkitBackingStorePixelRatio ||
  //       context.mozBackingStorePixelRatio ||
  //       context.msBackingStorePixelRatio ||
  //       context.oBackingStorePixelRatio ||
  //       context.backingStorePixelRatio ||
  //       1;
  //     const ratio = dpr / bsr;
  //     canvas.width = viewport.width * ratio;
  //     canvas.height = viewport.height * ratio;
  //     canvas.style.width = viewport.width + "px";
  //     canvas.style.height = viewport.height + "px";
  //     context.setTransform(ratio, 0, 0, ratio, 0, 0);
  //     // 渲染PDF文件到canvas元素里面
  //     let renderContext = {
  //       canvasContext: context,
  //       viewport: viewport,
  //     };
  //     let end = await page.render(renderContext).promise;
  //     // console.log("渲染完毕了", end);
  //   };
  //   // 终止执行代码
  //   return;
  // }
  // 文件是docx类型
  // if (
  //   res2.type ===
  //   "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  // ) {
  //   mydata.fileViewType = "docx";
  //   // 获取元素
  //   let docxBox = document.getElementById("docxBox");
  //   docxPreview.renderAsync(res2, docxBox, null, {
  //     className: "docx",
  //     inWrapper: false,
  //   });
  //   // 终止执行代码
  //   return;
  // }
  // // 文件是img类型
  // if (res2.type.includes("image")) {
  //   mydata.fileViewType = "image";
  //   // 获取元素
  //   let imageBox = document.getElementById("imageBox");
  //   let url = URL.createObjectURL(res2);
  //   imageBox.src = url;
  //   // 终止执行代码
  //   return;
  // }
}

//图书反馈
function bookCorrectionButton() {
  router.push({
    path: "/layout/list/bookCorrection",
  });
}

//正版验证
function testAndVerifyButton() {
  router.push({
    path: "/layout/list/testAndVerify",
  });
}

const loading = ref();

// 进度函数
function progressFn(resultNumber) {
  // 如果不可出现loading加载了，那么就直接终止代码
  if (!mydata.loadingShow) {
    return;
  }
  // console.log(112);

  // 赋值
  mydata.progressValue = resultNumber;
  // 需要注意的是，以服务的方式调用的全屏 Loading 是单例的。
  loading.value = ElLoading.service({
    lock: true,
    text: mydata.progressValue + "%",
    background: "rgba(255, 255, 255, 0.8)",
  });
  // 设置文本内容（它会执行多次）
  loading.value.setText(mydata.progressValue + "%");
  // 如果进度是100了，那就关闭loading加载（它可能不准确）
  if (mydata.progressValue === 100) {
    loading.value.close();
  }
}

async function downloadPdf() {
  let res = await examFileNoBlob({ id: mydata.examId });
    let arr1 = res.data.url.split(",");
  // 下载文件 start ///////////////////////////////////////
  for (const item of arr1) {
    let ele = document.createElement("a");
    ele.href = item;
    ele.click();
  }
  // 下载文件 end ///////////////////////////////////////
}
</script>

<style scoped lang="scss">
.my-li {
  > p:nth-of-type(1) {
    width: calc(100% - 100px);
    position: static !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    cursor: pointer;
  }
}

.my-rightLi {
  > p:nth-of-type(1) {
    width: calc(100% - 0px);
    position: static !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    cursor: pointer;
  }
}

////////整体设置column组件
:deep(.box-column) {
  // padding: 30px;
  ////
  li:hover {
    p:nth-of-type(2) {
      color: #009de0;
    }
  }

  li {
    margin-left: 20px;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    margin-bottom: 10px;
    // border: 1px solid red;
    position: relative;

    p:first-of-type {
      font-size: 14px;
      margin-bottom: 8px;
      line-height: 24px;
      white-space: nowrap; //不折行
      text-overflow: ellipsis; //文本溢出 用省略号显示
      overflow: hidden;
    }
    p:nth-of-type(2) {
      font-size: 14px;
      font-weight: 400;
      color: #888888;
      position: absolute;
      right: 0px;
      top: 2px;
    }
  }
  li:nth-last-of-type(1) {
    margin-bottom: 0px;
  }
  .column-title {
    border-bottom: 1px solid #cccccc;
    > p {
      display: none;
    }
  }
  .column-content {
    height: 200px;

    overflow: hidden;
    overflow-y: auto;
  }
}

.books-details {
  background-color: #f9f9f9;
  overflow: hidden;
  // border: 1px solid red;
  padding-bottom: 40px; //距离bottomBar的距离

  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 200px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 200px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 200px;
  //   // padding:30px;
  // }

  ///////输入框
  .box-input {
    width: 100%;
    // height: 100px;
    //   // border: 1px solid red;
    background-color: #ffffff;
    // border:1px solid red;
    padding: 10px 0px;
    :deep(.inputBox) {
      margin: 0 auto;
      display: block;
      // border:1px solid red;
    }
    //////按钮消失一个
    :deep(.el-button.el-button--primary.box2) {
      display: none;
    }
  }

  ////////最顶部的title
  .title-box {
    width: 343px;
    margin: 0 auto;
    // border: 1px solid blue;
    margin-top: 20px;
    margin-bottom: 10px;
    .title {
      // width: 860px;
      // height: 20px;
      // // border: 1px solid red;
      // display: flex;
      // justify-content: space-between;
      // align-items: center;
      // .title-left {
      //   // width:200px;
      //   // border:1px solid blue;
      //   display: flex;
      //   align-items: center;
      //   font-size: 14px;
      //   font-weight: 400;
      //   color: #bbbdbf;
      //   .line {
      //     margin: 0px 8px;
      //   }
      //   p:hover {
      //     color: #009de0;
      //   }
      // }
      .title-right {
        // width:60px;
        font-size: 16px;
        font-weight: 400;
        color: #bbbdbf;
        display: flex;
        align-items: center;
        justify-content: end;
        // position:relative;
        // border:1px solid blue;
        cursor: pointer;
        .el-icon {
          font-size: 24px;
          font-weight: 400;
          margin-right: 4px;
        }
      }
      .collectTrue {
        color: #009de0;
      }
      .title-right:hover {
        color: #009de0;
      }
    }
  }
  // :deep(.books-details.layout-router-view.box1){
  //   margin-bottom:0px !important;
  // }
  //////内容部分
  .box-content {
    width: 375px;
    // border: 1px solid red;
    margin: 0 auto;
    // margin-top: 21px;
    // margin-bottom:16px;
    // display: flex;
    // justify-content: space-between;

    /////左边内容部分
    .content-left {
      width: 375px;
      // height: 1608px;
      // border: 1px dashed rgb(102, 255, 0);
      background-color: #f9f9f9;
      // margin:0 auto;
      ////第一个模块---卷子标题盒子
      .left-1 {
        padding: 20px 16px;
        // border: 1px solid rgb(0, 17, 255);
        background-color: #ffffff;
        // .left-1-box1 {
        //   width: 800px;
        //   height: 62px;
        // border: 1px solid blue;
        > p {
          min-height: 28px;
          font-size: 18px;
          font-weight: 700;
          color: #333333;
          line-height: 28px;

          // border:1px solid red;
          display: -webkit-box;
          -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
          text-overflow: ellipsis; //文本溢出 用省略号显示
          -webkit-line-clamp: 2; //几行
          overflow: hidden;
        }
        //整个图标+字体的大盒子
        .icon-box {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          margin-top: 13px;
          // border: 1px solid blue;
          //每个图标+字体的小盒子
          > div {
            height: 24px;
            color: #9d9e9f;
            font-size: 14px;
            font-weight: 400;
            display: flex;
            align-items: center;
            :deep(.el-icon) {
              font-size: 14px;
              color: #9d9e9f;
              margin-top: 2;
              margin-right: 4px;
              // color:red;
            }
            > p {
              // margin-top: 1px;
              margin-right: 14px;
            }
          }
          .box-line {
            width: 1px;
            height: 13px;
            background-color: #e8e8e8;
            margin-left: 8px;
            margin-right: 8px;
          }
        }
        // }
        ////// 1/4页面
        .left-1-box2 {
          width: 343px;
          height: 38px;
          margin-top: 12px;
          // border: 1px solid rgb(200, 255, 0);
          border-bottom: 1px solid #cccccc;
          display: flex;
          justify-content: end;
          align-items: center;
          font-size: 14px;
          font-weight: 400;
          color: #000000;
        }
        //////卷子 + 锁的部分
        .left-1-box3 {
          width: 343px;
          // height: 1068px;
          margin-top: 4px;
          // border: 1px solid rgb(255, 81, 0);
          .box-one {
            overflow: auto;
            width: 100%;
            // height: 1068px;
            margin-bottom: 24px;
            // border: 1px solid rgb(0, 47, 255);
            // img {
            //   width: 100%;
            //   height: 1068px;
            // }
            #pdfCanvas {
              margin: 0 auto !important;
              display: block;
            }
          }
          //锁的部分
          .box-two {
            width: 343px;
            height: 24px;
            margin: 0 auto;
            // border: 1px solid rgb(255, 230, 0);
            display: flex;
            align-items: center;
            :deep(.el-divider__text.is-center) {
              display: flex;
              justify-content: center;
              align-items: center;
              .el-icon {
                margin-right: 6px;
                color: #ddaf77;
                font-size: 16px;
              }
              p {
                color: #333333;
                margin-top: -1px;
              }
            }
            :deep(.el-divider.el-divider--horizontal) {
              color: #ddaf77;
            }
          }
        }
        //////按钮部分
        .left-1-box4 {
          width: 343px;
          height: 30px;
          margin: 0 auto;
          margin-top: 26px;
          display: flex;
          justify-content: center;
          align-items: center;
          // border: 1px solid rgb(25, 0, 255);
          //第一个按钮
          // :deep(.el-button.el-button--warning.is-round) {
          :deep(.el-button.el-button--primary.is-plain) {
            width: 120px;
            height: 30px;
            border-radius: 30px;
            margin-right: 20px;
            // background-color: #ffe3a3;
            // color: #7f5112;
            font-size: 14px;
            font-weight: 400;
            border: none;
          }

          //第二个按钮
          :deep(.el-button.el-button--success.is-plain) {
            width: 120px;
            height: 30px;
            border-radius: 30px;
            // background-color: #f9f9f9;
            // border: 1px solid #009de0;
            // color: #009de0;
            font-size: 14px;
            font-weight: 400;
          }
        }
      }
    }
    //////右边
    .content-right {
      // width: 320px;
      //////相关资源 部分
      .left-1-box5 {
        margin: 0 auto;
        margin-bottom: 16px;
        overflow: hidden;
        :deep(.box-column) {
          height: 100%;
          margin-top: 16px;
          // background: linear-gradient(
          //   180deg,
          //   #fdeff1 0%,
          //   rgba(255, 255, 255, 0.2) 145px,
          //   #ffffff 100%
          // );
        }
      }

      //////热门资源部分
      .left-2-box {
        margin: 0 auto;
        margin-top: 16px;
        margin-bottom: 16px;
        overflow: hidden;
        :deep(.box-column) {
          height: 100%;
          // margin-bottom: 24px;
          // background: linear-gradient(
          //   180deg,
          //   #fdeff1 0%,
          //   rgba(255, 255, 255, 0.2) 145px,
          //   #ffffff 100%
          // );
        }
      }

      //必学好课
      :deep(.box-column.column3) {
        .column-content {
          height: 132px;
        }
      }

      .bookBox {
        width: 343px;
        // height: 156px;
        // border:1px solid red;
        border-radius: 8px;
        margin: 0 auto;
        // background-image: url("@/assets/image 128.png");
        margin-bottom: 20px;
        > img {
          width: 100%;
          border-radius: 8px;
          display: block;
        }
      }
      .genuineVerify {
        margin-bottom: 0px;
      }
    }
  }
}
</style>
